import { Button } from "components/DesignSystem/Button/Button";
import Modal from "components/DesignSystem/Modal/Modal";
import RadioGroup from "components/DesignSystem/RadioGroup/RadioGroup";
import { LinkableFinancialClosing } from "store/apis/requestDocument";
import { formatDate } from "utils/formatDate";
import { humanize } from "utils/humanize";

const formatPeriod = ({ start_date, end_date }: LinkableFinancialClosing) =>
  `${formatDate(start_date)} – ${formatDate(end_date)}`;

const closingSubtext = ({ task, status }: LinkableFinancialClosing) =>
  task?.title || (status ? humanize(status) : "");

export const LinkFinancialClosing = ({
  closings,
  selectedClosingId,
  onSelect,
  onNext,
  onCancel,
}: {
  closings: LinkableFinancialClosing[];
  selectedClosingId: string | null;
  onSelect: (closingId: string) => void;
  onNext: () => void;
  onCancel: () => void;
}) => (
  <Modal.Content size="regular">
    <Modal.Header>
      <Modal.Title>Link to financial closing</Modal.Title>
      <Modal.Close />
    </Modal.Header>
    <Modal.Body className="sm:t-px-4">
      <div className="t-flex t-flex-col t-gap-3">
        <span className="t-text-body-sm t-text-text-30">
          Select the financial closing this document request is for.
        </span>
        <RadioGroup.Root
          value={selectedClosingId ?? ""}
          onValueChange={onSelect}
        >
          <RadioGroup.Content className="t-flex t-flex-col t-gap-3">
            {closings.map((closing) => (
              <RadioGroup.Item
                key={closing.uuid}
                value={closing.uuid}
                description={closingSubtext(closing) || undefined}
              >
                {formatPeriod(closing)}
              </RadioGroup.Item>
            ))}
          </RadioGroup.Content>
        </RadioGroup.Root>
      </div>
    </Modal.Body>
    <Modal.Footer>
      <div className="t-flex t-justify-end t-gap-2">
        <Button type="button" onClick={onCancel}>
          Cancel
        </Button>
        <Button
          type="button"
          customType="primary"
          onClick={onNext}
          disabled={!selectedClosingId}
        >
          Next
        </Button>
      </div>
    </Modal.Footer>
  </Modal.Content>
);
